/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowUp: {
  name: 'arrow-up';
  data: string;
} = {
  name: 'arrow-up',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 20a1 1 0 0 0 1-1V7.414l4.293 4.293a1 1 0 0 0 1.414-1.414l-6-6a1 1 0 0 0-1.414 0l-6 6a1 1 0 1 0 1.414 1.414L11 7.414V19a1 1 0 0 0 1 1Z" fill="currentColor"/></svg>`,
};
